import { render, staticRenderFns } from "./filesBrowse.vue?vue&type=template&id=06dec074&scoped=true"
import script from "./filesBrowse.vue?vue&type=script&lang=js"
export * from "./filesBrowse.vue?vue&type=script&lang=js"
import style0 from "./filesBrowse.vue?vue&type=style&index=0&id=06dec074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dec074",
  null
  
)

export default component.exports